<template>
  <div class="review-g2">
    <div class="gradient" />
    <UiComponentTag
      v-if="hasTag"
      type="secondary"
    >
      <slot name="tag" />
    </UiComponentTag>
    <UiComponentHeading
      as="paragraph"
      :level="3"
    >
      <slot name="heading" />
    </UiComponentHeading>
    <div class="medals">
      <UiComponentImage
        v-for="({ image }, index) in medals.filter(({ image }) => image)"
        :key="`medal-${index}-${expectedSize}`"
        :alt="image.alt"
        :class="`medal medal-${index + 1}`"
        :expected-size="expectedSize"
        :extra-params="{ trim: 'auto' }"
        :height="image.height"
        :source="image.url"
        use-natural-width
        :width="image.width"
      />
    </div>
  </div>
</template>

<script setup>
// Composables
const slots = useSlots()
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  medals: {
    default() {
      return []
    },
    required: false,
    type: Array,
  },
})

// Computed Properties
const expectedSize = computed(() => {
  return screenWidth.value < 768 ? 110 : 137
})

const hasTag = computed(() => {
  const node = slots && slots.tag && slots.tag()
  return node && node.length > 0
})
</script>

<style lang="postcss" scoped>
.review-g2 {
  @apply relative flex flex-col items-center w-full p-6 rounded-4xl overflow-hidden;
  background-color: #fdf7f7;

  @screen md {
    @apply p-8;
  }

  @screen xl {
    @apply flex-grow justify-center;
  }

  .gradient {
    @apply absolute z-0;
    width: 935.9px;
    height: 935.9px;
    left: -347.62px;
    top: -348.43px;
    background: radial-gradient(
      50% 50% at 50% 50%,
      rgba(218, 73, 75, 0.1) 0%,
      rgba(218, 73, 75, 0) 100%
    );
  }

  .tag {
    @apply self-center z-10;
    background-color: #fdf7f7 !important;
    color: #943124 !important;
  }

  .h3 {
    @apply mt-4 text-center z-10;

    @screen md {
      @apply mt-6;
    }
  }

  .medals {
    @apply relative flex w-full mt-8 z-10;
    height: 110px;
    width: 295px;

    @screen md {
      @apply mt-10;
      height: 137px;
      width: 366px;
    }

    .medal {
      @apply absolute top-0 rounded-none;

      &.medal-1 {
        left: 9.83559322%;
        transform: translateX(-50%) translateY(4.4%) scale(0.68257562035);
        z-index: 10;
      }

      &.medal-2 {
        left: 28.142372881%;
        transform: translateX(-50%) translateY(4%) scale(0.91007063937);
        z-index: 20;
      }

      &.medal-3 {
        filter: drop-shadow(0px 12.8962px 25.7923px rgba(13, 22, 38, 0.04))
          drop-shadow(0px 6.44809px 12.8962px rgba(13, 22, 38, 0.04))
          drop-shadow(0px 3.22404px 6.44809px rgba(13, 22, 38, 0.04))
          drop-shadow(0px 1.61202px 3.22404px rgba(13, 22, 38, 0.04))
          drop-shadow(0px 0.806011px 1.61202px rgba(13, 22, 38, 0.04));
        left: 50%;
        transform: translateX(-50%);
        z-index: 30;
      }

      &.medal-4 {
        left: 71.857627119%;
        transform: translateX(-50%) translateY(4%) scale(0.91007063937);
        z-index: 20;
      }

      &.medal-5 {
        left: 90.16440678%;
        transform: translateX(-50%) translateY(4.4%) scale(0.68257562035);
        z-index: 10;
      }
    }
  }
}
</style>
